import React, { useState } from "react";
import Section from "./Section";
import { X_PADDING } from "../constants";
import Page from "./Page";
import {
  FaHandshake,
  FaBuilding,
  FaUniversity,
  FaHospital,
  FaUsers,
  FaGlobeAfrica,
} from "react-icons/fa";

const Partners = () => {
  return (
    <Page name="Partners">
      <div className="w-full pt-8 bg-white">
        {/* Partners Section */}
        <Section
          name="Our Associates"
          description="COAZ collaborates with government agencies, healthcare institutions, and 
          other stakeholders to strengthen the role of clinical officers in Zambia's 
          healthcare system. Learn more about our partnerships and how we work 
          together to advocate for quality healthcare delivery and professional 
          advancement."
        />

        {/* Partner Logos Grid */}
        <div className={`${X_PADDING} w-full mx-auto py-12`}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* HPCZ */}
            <PartnerCard
              logo="/images/hpcz.png"
              name="Health Professions Council of Zambia"
              abbreviation="HPCZ"
              description="Collaborates in enforcement of regulations, standards of practice and other functions"
              icon={<FaHospital className="text-[#1477c2] text-2xl" />}
            />

            {/* HEA */}
            <PartnerCard
              logo="/images/hea.png"
              name="Higher Education Authority"
              abbreviation="HEA"
              description="Collaborates with the Higher Education Authority in matters of training and other matters related"
              icon={<FaUniversity className="text-[#1477c2] text-2xl" />}
            />

            {/* Ministry of Health */}
            <PartnerCard
              logo="/images/moh.png"
              name="Ministry of Health"
              abbreviation="MoH"
              description="Providing Health services and enforcing standards in health service delivery"
              icon={<FaBuilding className="text-[#1477c2] text-2xl" />}
            />

            {/* Local Authority */}
            <PartnerCard
              logo="/images/local_authority.png"
              name="Local Authority"
              abbreviation="LA"
              description="Works to strengthen local involvement in Health services and others"
              icon={<FaUsers className="text-[#1477c2] text-2xl" />}
            />
          </div>
        </div>

        {/* Additional Partners Section */}
        <div className={`${X_PADDING} w-full mx-auto pb-16`}>
          <div className="bg-[#f8fafb] rounded-xl p-8 md:p-10 border border-[#eef1f4]">
            <div className="flex items-center gap-3 mb-6">
              <FaGlobeAfrica className="text-[#1477c2] text-2xl" />
              <h3 className="text-xl font-bold text-[#16365c]">
                Other Partners & Stakeholders
              </h3>
            </div>
            <p className="text-[#7c8a97] text-sm leading-relaxed">
              COAZ continues to build strategic partnerships with various
              organizations and institutions to advance the clinical profession
              and improve healthcare delivery in Zambia. These collaborations
              are essential in shaping policies, enhancing training standards,
              and ensuring quality healthcare services across the nation.
            </p>
          </div>
        </div>

        {/* CTA Banner */}
        <div className="bg-[#1477c2] py-10">
          <div
            className={`${X_PADDING} w-full mx-auto flex flex-col md:flex-row items-center justify-between gap-4`}
          >
            <h2 className="text-white text-2xl font-semibold">
              Learn more about our partnerships and how we work together
            </h2>
            <button className="bg-white text-[#1477c2] px-8 py-3 rounded-full font-semibold hover:bg-[#eef7fd] transition">
              Read More
            </button>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default Partners;

// Partner Card Component
const PartnerCard = ({ logo, name, abbreviation, description, icon }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className="bg-white rounded-xl border border-[#eef1f4] overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {/* Logo Section */}
      <div className="h-40 bg-[#f8fafb] flex items-center justify-center p-6 border-b border-[#eef1f4]">
        {logo ? (
          <img
            src={logo}
            alt={name}
            className="max-h-full max-w-full object-contain"
          />
        ) : (
          <div className="w-16 h-16 rounded-full bg-[#eef7fd] flex items-center justify-center">
            {icon}
          </div>
        )}
      </div>

      {/* Content Section */}
      <div className="p-5">
        <div className="flex items-start justify-between mb-2">
          <h4 className="text-sm font-bold text-[#16365c] leading-tight">
            {name}
          </h4>
          <span className="text-xs font-semibold text-[#1477c2] bg-[#eef7fd] px-2 py-0.5 rounded-full whitespace-nowrap ml-2">
            {abbreviation}
          </span>
        </div>
        <p className="text-[#7c8a97] text-xs leading-relaxed">{description}</p>
      </div>
    </div>
  );
};
